import { makeStyles } from "@material-ui/core";
import { getColorFromUrl, isColorUrl } from "~/utils/business";
import { colors } from "~/utils/colors";

const {background} = colors;

const MuiStylesTitleContainer = makeStyles((theme) => ({
	header: {
		// boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.08)",
		padding: "4%",
	},

	title: {
		fontFamily: "SFUIText",
		fontSize: "14px",
		fontWeight: 300,
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		textAlign: "center",
		color: "#474747",
	},

	subtitle: {
		marginTop: "2%",
		width: "60%",
		fontFamily: "SFUIText",
		fontSize: "17px",
		fontWeight: 900,
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		color: "rgba(71, 71, 71, 0.82)",
	},
	container: (props) => {
		const isColorUrlResult = isColorUrl(props?.imageUrl);
		const colorBackground = isColorUrlResult ? getColorFromUrl(props?.imageUrl) : null;
		const hasImage = !!props?.imageUrl && !!props?.imageVisible;
		const showGradient = props?.showGradient !== false;
		const hasImageCustom = !!props?.imageCustom;

		return {
		  maxWidth: "480px",
		  margin: "auto",
		  padding: 0,
		  display: "flex",
		  flexDirection: "column",
		  maxHeight: 'auto',
		  backgroundColor: props?.backgroundNew ? background?.secondary : "transparent",
		  ...((isColorUrlResult && props?.backgroundNew) && {
			backgroundColor: colorBackground,
		  }),
		  ...(
			hasImageCustom && {
				backgroundImage: `url(${props?.imageCustom})`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
				backgroundSize: 'cover',
			}
		  ),
		  ...(
			(hasImage && showGradient && !hasImageCustom) && !isColorUrlResult && {
				backgroundImage: `linear-gradient(to top, rgba(25, 20, 14, 1) 48%, rgba(25, 20, 14, 0.1) 62%), url(${props?.imageUrl})`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center top',
				backgroundSize: '120%',
			}
		  ),
		  ...(
			(hasImage && !showGradient && !hasImageCustom) && !isColorUrlResult && {
				backgroundImage: `linear-gradient(rgba(60, 40, 30, 0.6), rgba(60, 40, 30, 0.6)), url(${props?.imageUrl})`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center top',
				backgroundSize: '120%',
				[theme.breakpoints.up('xl')]: {
					backgroundImage: `linear-gradient(rgba(60, 40, 30, 0.45), rgba(60, 40, 30, 0.45)), url(${props?.imageUrl})`,
				}
			}
		  ),
		};
	},
	children: (props) => {
		return {
			height: 'inherit',
			minHeight: 'inherit',
			padding: '4%',
		}
	},

	containerFloatingButton: {
		position: 'absolute',
		top: 10,
		right: 15,
		zIndex: 1000,
		margin: '0 auto',
		maxWidth: '480px',
	},

	floatingButton: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: '#fff',
		border: 'none',
		color: '#000',
		fontSize: '12px',
		borderRadius: '20px',
		boxShadow: 'none',
	},
}));

export default MuiStylesTitleContainer;
